var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBinanceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 2,
    fill: "#F3BA2F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M8 3l1.6 1.6L7.2 7 8 7.8l2.4-2.4L12 7l-4 4-4-4 1.6-1.6L8 7.8l.8-.8L6.4 4.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinanceIcon);
export default __webpack_public_path__ + "static/media/binance_icon.8797daa8264e4aafa6da01e21d520203.svg";
export { ForwardRef as ReactComponent };